module.exports = __webpack_public_path__ + "media/images/non-electron-249338b0ad2d501a7cbc5dd011e9e30d.svg";